// @flow
import * as React from 'react'
import InternalServerError from './InternalServerError'
import NotFoundError from './NotFoundError'

type Props = {
  children: React.Node,
}

type State = {
  notFoundError: any,
  internalServerError: any,
}

export default class ErrorBoundary extends React.Component<Props, State> {
  state = {
    notFoundError: undefined,
    internalServerError: undefined,
  }

  render = () => {
    if (this.state.notFoundError) return this.renderNotFoundError()
    if (this.state.internalServerError) return this.renderInternalServerError()

    return this.props.children
  }

  componentDidCatch = (error: any) => {
    if (NotFoundError.isNotFoundError(error)) this.setState({ notFoundError: error })
    if (InternalServerError.isInternalServerError(error))
      this.setState({ internalServerError: error })
  }

  renderNotFoundError = () => {
    return <p>Not Found</p>
  }

  renderInternalServerError = () => {
    return <p>Internal Server Error</p>
  }
}
